module.exports = __webpack_public_path__ + "img/golden_oak_690l_list.a0e5c7ae.jpg";